module.exports = __webpack_public_path__ + "static/media/big-bg.d79f2ca5.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/CSS/assets-minified/dummy-images/big-bg.jpeg
// module id = ./src/CSS/assets-minified/dummy-images/big-bg.jpeg
// module chunks = 0